import styled from "styled-components";
import { CssRule } from "../../../../themes/architecture/css-helpers/css-rule";
import {styledByDevice} from "../../../../themes/architecture/styled-by-device";

const DefaultBox = styled.div`
    width: 450px;
    padding: 10px;
`;

export const PcBox = styled(DefaultBox)`
    @media ${({theme}) => theme.mediaQuery.xlAndBelow} {
          width: 390px;
    }
`;

export const MobileBox = styled(DefaultBox)`
    width: 100%;
    ${CssRule.For.mobile.tablet.build()} & {
          width: 450px;
    }
`;

export const LinkToOfferBannerDefaultBox =  styledByDevice(PcBox, MobileBox);